import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import { Box, Button } from '@mui/material';
const day_names = [
    { id: 0, day_name: 'ПН' },
    { id: 1, day_name: 'ВТ' },
    { id: 2, day_name: 'СР' },
    { id: 3, day_name: 'ЧТ' },
    { id: 4, day_name: 'ПТ' },
    { id: 5, day_name: 'СБ' },
    { id: 6, day_name: 'ВС' },
];
const WeekdaysToggles = memo(function WeekdaysToggles(props) {
    const { bitmap, onChangeBitmap } = props;
    const days = useMemo(() => day_names.map(({ id, day_name }) => {
        const is_day_selected = (bitmap & (1 << id)) !== 0;
        return (_jsx(Button, { variant: is_day_selected ? 'contained' : 'outlined', color: is_day_selected ? 'primary' : 'neutral', onClick: () => onChangeBitmap(bitmap ^ (1 << id)), style: { minWidth: '0' }, children: day_name }, id));
    }), [day_names, onChangeBitmap]);
    return (_jsx(Box, { display: "grid", gridTemplateRows: "repeat(auto-fill, minmax(40px, 1fr))", gridTemplateColumns: "repeat(auto-fill, minmax(70px, 1fr))", width: "100%", gap: 1, children: days }));
});
export { WeekdaysToggles };
